import { render, staticRenderFns } from "./NotificationHandler.vue?vue&type=template&id=97c6a4e6&scoped=true&"
import script from "./NotificationHandler.vue?vue&type=script&lang=js&"
export * from "./NotificationHandler.vue?vue&type=script&lang=js&"
import style0 from "./NotificationHandler.vue?vue&type=style&index=0&id=97c6a4e6&prod&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../../../../../../../../bankari hypo/BankariBroker/frontend/node_modules/@vue/vue-loader-v15/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "97c6a4e6",
  null
  
)

export default component.exports